
export const sliderItems = [
    {
      id: 1,
      img: "https://i.ibb.co/SrKTvy0/two-beautiful-women-shopping-town.jpg",

      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f3f9fd8f",
      style:{objectPosition:"20% 100%"},
      
    },
    {
      id: 2,
      img: "https://i.ibb.co/G5Rhv7g/beautiful-smiling-young-blonde-woman-pointing-sunglasses-holding-shopping-bags-credit-card-pink-wall.jpg" ,
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
      style:{objectPosition:"30% 50%"}
    },
    {
      id: 3,
      img: "https://i.ibb.co/TkqkNQC/headphones-african-american-woman-s-portrait-isolated-dark-studio-background-multicolored-neon-light.jpg",

      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
      style:{objectPosition:"70% 50%"}
    },
    {
      id: 4,
      img: "https://i.ibb.co/qsSXYtq/shoppers-talking-center.jpg",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
      style:{objectPosition:"110% 50%"}
    },
    {
      id: 5,
      img: "https://i.ibb.co/cxspLtX/happy-beautiful-couple-posing-with-shopping-bags-violet.jpg",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "edf6fc",
      style:{objectPosition:"40% 50%"}
    },
    {
      id: 6,
      img: "https://i.ibb.co/MG370Cv/family-mall.jpg" ,

      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
      style:{objectPosition:"70% 50%"}
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://i.ibb.co/yNLMGyK/handsome-man-wearing-sunglasses-standing-grey-wall.jpg",
      title: "SHIRT STYLE!",
      categ:"shirt",
      style:{ objectPosition: "center 10%"}
    },
    {
      id: 2,
      img: "https://i.ibb.co/ynr3SKt/pexels-ray-piedra-1476209.jpg",
      
      title: "FOOTWEAR",
      categ:"footwear"
    },
    {
      id: 3,
      img:"https://i.ibb.co/3skpb7c/pexels-cottonbro-studio-6800319.jpg" ,
      title: "LIGHT JACKETS",
      categ:"Jackets"
    },
  ];

 